import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { SlTypographyComponent } from '../sl-typography/sl-typography.component';
import { SlButtonComponent } from '../sl-button/sl-button.component';

enum InputType {
  STANDARD = 'standard',
  PASSWORD = 'password',
}
@Component({
  standalone: true,
  selector: 'sl-input',
  templateUrl: './sl-input.component.html',
  styleUrls: ['./sl-input.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SlTypographyComponent,
    SlButtonComponent,
  ],
})
export class SlInputComponent implements OnInit {
  @Input() id?: string;
  @Input({ required: true }) label!: string;
  @Input() placeholder?: string = '';
  @Input() assistiveText?: string = '';
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() mode: 'standard' | 'brand' | 'dark' = 'standard';
  @Input() variant: 'text' | 'textarea' = 'text';
  @Input() type: InputType = InputType.STANDARD;
  @Input() required?: boolean = false;
  @Input() control: FormControl = new FormControl({
    value: undefined,
    disabled: true,
  });
  @Input() ariaLabel?: string;
  @Input() icon?: string;
  @Input() isReadOnly?: boolean;
  @Input() isClickable?: boolean;
  @Input() maxLength = '350';
  @Input() fullWidth = false;
  @Input() disabled = false;
  @Output() iconClick = new EventEmitter<Event>();

  charCount = 0;
  showPassword = false;

  ngOnInit() {
    if (this.variant === 'textarea' && this.control) {
      const validators = [
        this.control.validator,
        Validators.maxLength(+this.maxLength),
      ].filter((x) => x !== null && x !== undefined);
      this.control.setValidators(validators);
      //If validation is on submit, this is only triggered when submitting or control.reset() is called in the parent
      this.control.valueChanges.subscribe((value) => {
        if (!value) {
          this.charCount = 0;
        }
      });
    }
  }

  //Needed for it to work on both modes (change and submit)
  onChangeTextArea(event: Event) {
    const eventCasted = event.target as HTMLTextAreaElement;

    this.charCount = eventCasted.value.length;
  }

  onClickShowPassword() {
    this.showPassword = !this.showPassword;
  }

  handleIconClick() {
    this.iconClick.emit();
  }

  onKeyUpShowPassword(event: KeyboardEvent) {
    const pressedKey = event.key;

    if (pressedKey === ' ' || pressedKey === 'enter') {
      event.preventDefault();
      this.showPassword = !this.showPassword;
    }
  }

  getErrorMessage() {
    if (!this.control.errors) return null;

    const firstErrorKey = Object.keys(this.control.errors)[0];

    return this.errorMessages[firstErrorKey];
  }

  getTagColor() {
    if (this.mode === 'standard' && this.disabled) {
      return 'var(--color-neutral-40)';
    }
    if (this.mode === 'standard' && !this.disabled) {
      return 'var(--color-neutral-90)';
    }

    return 'var(--color-neutral-10)';
  }
}
